// Third-party
import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router';

// Utils
import { NAV_PATHS } from '../../../../utils/constants';
import { ProposalTemplateUtils } from '../../ProposalTemplateUtils';

// Components
import { ProposalPage } from '../../../../views/containers/proposal';
import { SelectProposalTemplateModal } from '@/views/components/modals';

// Actions
import { setProposalTemplate } from '../../../../redux/modules/proposal-v2';

// Types
import * as ProposalNS from '../../Proposal';
import { ReduxState } from '../../../../redux/modules/types';
import Comparison from '@/types/comparison';
import User from '@/types/user';

type StateProps = {
  user?: User | null;
  proposalTemplate?: ProposalNS.BaseProposalTemplate;
  comparison?: Comparison;
  templates: ProposalNS.BaseProposalTemplate[];
  defaultTemplate?: string;
};

type DispatchProps = {
  setProposalTemplate: (template: ProposalNS.BaseProposalTemplate, setDefault?: boolean) => void;
};

type Props = StateProps & DispatchProps;

type State = {
  showSelectTemplateModal: boolean;
};

class ProposalTemplateRouter extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    const { templates, defaultTemplate } = this.props;

    this.state = {
      showSelectTemplateModal: templates.length > 1 && !defaultTemplate,
    };
  }

  onHideSelectTemplateModal = () => {
    this.setState({ showSelectTemplateModal: false });
  };

  onSelectTemplate = (templateKey: string, setDefault?: boolean) => {
    const { templates } = this.props;

    const selectedTemplate = templates.find(template => template.key === templateKey);

    if (selectedTemplate) {
      this.props.setProposalTemplate(selectedTemplate, setDefault);
    }

    this.setState({ showSelectTemplateModal: false });
  };

  showTemplateSelectionModal = () => {
    this.setState({ showSelectTemplateModal: true });
  };

  renderBuilder = () => {
    const { proposalTemplate, comparison, user } = this.props;

    if (!comparison) {
      return <Redirect to={NAV_PATHS.COMPARISONS} />;
    }

    if (!proposalTemplate || !user) {
      return null;
    }

    return <ProposalPage user={user} proposalTemplate={proposalTemplate as ProposalNS.ProposalTemplateV2} onChangeTemplate={this.showTemplateSelectionModal} />;
  };

  getTemplatesWithMissingRequirements = () => {
    const { templates, comparison } = this.props;
    if (!comparison) {
      return [];
    }
    return ProposalTemplateUtils.getTemplatesWithFormattedMissingRequirements(comparison, templates);
  };

  render() {
    const { templates } = this.props;
    const { showSelectTemplateModal } = this.state;

    return (
      <>
        {this.renderBuilder()}

        <SelectProposalTemplateModal
          show={showSelectTemplateModal}
          onSelect={this.onSelectTemplate}
          onCancel={this.onHideSelectTemplateModal}
          templates={templates}
          templatesWithMissingRequirements={this.getTemplatesWithMissingRequirements()}
        />
      </>
    );
  }
}

const mapStateToProps = (state: ReduxState): StateProps => {
  const currentComparison = state.comparison.activeComparison;

  return {
    user: state.auth.user,
    comparison: currentComparison,
    proposalTemplate: state.proposalV2.selectedTemplate,
    templates: state.proposalV2.templates,
    defaultTemplate: state.proposalV2.defaultTemplate,
  };
};

export default connect(mapStateToProps, {
  setProposalTemplate,
})(ProposalTemplateRouter);
